import { render, staticRenderFns } from "./MaterialIconButton.vue?vue&type=template&id=2e689924&scoped=true"
import script from "./MaterialIconButton.vue?vue&type=script&lang=js"
export * from "./MaterialIconButton.vue?vue&type=script&lang=js"
import style0 from "./MaterialIconButton.vue?vue&type=style&index=0&id=2e689924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e689924",
  null
  
)

export default component.exports